/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PendingEvaluation } from './pendingEvaluation';

export type GenericApiResponseListPendingEvaluationData = PendingEvaluation[] | null;
